import DashboardHero from './DashboardHero';

export default DashboardHero;
